import { createAction } from 'deox';
import { CLOSE_AUTH_MODAL, OPEN_AUTH_MODAL, SET_FORGOT_TEXT } from './types';

export const openAuthModal = createAction(OPEN_AUTH_MODAL, (res) => (params) => res(params));

export const closeAuthModal = createAction(CLOSE_AUTH_MODAL);

export const setForgotText = createAction(SET_FORGOT_TEXT, (res) => (params) => res(params));
